import { getInitialState, getPath } from "../../utils";
import ActionTypes from "../actions/ActionTypes";

const initialState = {
  scheduledNotificationsList: [],
  prevPage: -1,
  nextPage: -1,
  activeFilters: {},
  activeCampaignDetails: {},
  newCampaignOptions: {},
  currentLastEvaluatedKey : "",
  lastEvaluatedKeyList : []
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SET_SCHEDULED_NOTIFICATIONS_LIST:
      return setScheduledNotificationsList(state, action);
    case ActionTypes.SET_ACTIVE_CAMPAIGN:
      return setActiveCampaign(state, action);
    case ActionTypes.SET_ACTIVE_FILTERS_DRIVER_NOTIFICATION:
      return setActiveFilters(state, action);
    case ActionTypes.SET_NEW_CAMPAIGN_OPTIONS:
      return setNewCampaignOptions(state, action);
    case ActionTypes.RESET_STATE:
      return resetState(state, action);
    case ActionTypes.REMOVE_LAST_EVALUATED_KEY_FROM_LIST:
      return removeLastEvaluatedKeyFromList(state);
    case ActionTypes.EMPTY_LAST_EVALUATED_KEY_LIST:
        return emptyLastEvaluatedKeyList(state);
    default:
      return state;
  }
}

const removeLastEvaluatedKeyFromList = (state) => {
  // remove last two elements from the list
  return {
    ...state,
    lastEvaluatedKeyList: state.lastEvaluatedKeyList.slice(0, -2),
  }
}
const emptyLastEvaluatedKeyList = (state) => {
    return {
        ...state,
        lastEvaluatedKeyList: [],
    }

}
const resetState = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};

const setScheduledNotificationsList = (state, action) => {
  return {
    ...state,
    scheduledNotificationsList: getPath(action.payload, "campaigns", []),
    prevPage: getPath(action.payload, "page_response.previous_page", -1),
    nextPage: getPath(action.payload, "page_response.next_page", -1),
    currentLastEvaluatedKey: getPath(action.payload, "pageResponse.last_evaluated_key", ""),
    lastEvaluatedKeyList: [...state.lastEvaluatedKeyList, getPath(action.payload, "pageResponse.last_evaluated_key", "")],
  };
};

const setActiveCampaign = (state, action) => {
  return {
    ...state,
    activeCampaignDetails: action.payload,
  };
};

const setActiveFilters = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};

const setNewCampaignOptions = (state, action) => {
  return {
    ...state,
    newCampaignOptions: action.payload,
  };
};
